import { type Provider } from '@angular/core';

import { provideChdDxBackend, provideChdMaterialBackend } from '@cp-produkte/cruise-hospitality-design';

import { ChdButtonSpaRenderer } from '@components/chd-button-spa-renderer/chd-button-spa-renderer.component';
import { ChdCardSpaRenderer } from '@components/chd-card-spa-renderer/chd-card-spa-renderer.component';
import { ChdChipSetSpaRenderer } from '@components/chd-chip-set-spa-renderer/chd-chip-set-spa-renderer.component';
import { ChdChipSpaRenderer } from '@components/chd-chip-spa-renderer/chd-chip-spa-renderer.component';
import { ChdIconButtonSpaRenderer } from '@components/chd-icon-button-spa-renderer/chd-icon-button-spa-renderer.component';
import { ChdNavigationMenuMaterialSpaRenderer } from '@components/chd-navigation-menu-material-spa-renderer/chd-navigation-menu-material-spa-renderer.component';
import { ChdNavigationMenuSpaRenderer } from '@components/chd-navigation-menu-spa-renderer/chd-navigation-menu-spa-renderer.component';
import {
  ChdTabNavPanelSpaRenderer,
  ChdTabNavSpaRenderer,
} from '@components/chd-tab-nav-spa-renderer/chd-tab-nav-spa-renderer.component';
import { ChdTableSpaRenderer } from '@components/chd-table-spa-renderer/chd-table-spa-renderer.component';
import { ChdTimeInputSpaRenderer } from '@components/chd-time-input-spa-renderer/chd-time-input-spa-renderer.component';
import { readChdBackendPreference } from '@services/chd-backend.service';

export function provideConfiguredChdBackend(): Provider[] {
  if (readChdBackendPreference() === 'dx') {
    return provideChdDxBackend({
      button: ChdButtonSpaRenderer,
      card: ChdCardSpaRenderer,
      chip: ChdChipSpaRenderer,
      chipSet: ChdChipSetSpaRenderer,
      iconButton: ChdIconButtonSpaRenderer,
      navigationMenu: ChdNavigationMenuSpaRenderer,
      tabNav: ChdTabNavSpaRenderer,
      tabNavPanel: ChdTabNavPanelSpaRenderer,
      table: ChdTableSpaRenderer,
      timeInput: ChdTimeInputSpaRenderer,
    });
  }

  return provideChdMaterialBackend({ navigationMenu: ChdNavigationMenuMaterialSpaRenderer });
}
